<template>
  <wdw-dynbox :title="domainStore.translate('user.profile.menu-item.password')">
    <Form @submit="onSubmitChangePasswordForm">
      <div id="wdw-changepassword-form" class="wdw-form">
        <form-control-input
          :label="domainStore.translate('user.profile.password.current-label')"
          type="password"
          name="old_password"
          code="old_password"
          :serverError="data.errors['old_password']"
          :required="toBool(1, true)"
          :public="toBool(1, true)"
          :hidden="toBool(0, false)"
          :help="domainStore.translate('user.profile.password.current-help')"
          parentFormId="wdw-changepassword-form"
          defaultvalue=""
        />
        <p />
        <form-control-input
          :label="domainStore.translate('user.profile.password.new-label')"
          type="password"
          name="new_password"
          code="new_password"
          :serverError="data.errors['new_password']"
          :required="toBool(1, true)"
          :public="toBool(1, true)"
          :hidden="toBool(0, false)"
          :help="domainStore.translate('user.form.message.password-register-help')"
          parentFormId="wdw-changepassword-form"
          defaultvalue=""
        />
        <p />
        <form-control-input
          :label="domainStore.translate('user.profile.password.new-repeat-label')"
          type="password"
          name="new_password_repeat"
          code="new_password_repeat"
          :serverError="data.errors['new_password_repeat']"
          :required="toBool(1, true)"
          :public="toBool(1, true)"
          :hidden="toBool(0, false)"
          parentFormId="wdw-changepassword-form"
          defaultvalue=""
        />
        <p />
        <div class="alert alert-info" role="alert">
          <p
            v-dompurify-html="
              domainStore.translate('user.form.message.password-register-help-extra') + ' ' + passwordAllowedCharacters
            "
          ></p>
        </div>
        <button type="submit" class="btn btn-primary btn-form-submit" :disabled="data.loading" name="submit">
          {{ domainStore.translate('user.profile.password.submit') }}
        </button>
        &nbsp;
        <button
          type="button"
          class="btn btn-default btn-form-cancel"
          :disabled="data.loading"
          name="cancel"
          @click="emitClose()"
        >
          {{ domainStore.translate('user.form.cancel') }}
        </button>
        <vue-loading v-if="data.loading" />
      </div>
    </Form>
  </wdw-dynbox>
</template>

<script>
import { userStore } from '@/store/user-store';
import { domainStore } from '@/store/domain-store';
import useConverter from '@/composables/general/useConverter';
import { onMounted, reactive, computed, ref } from 'vue';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import { RepositoryFactory } from '@/api/repositoryFactory';

import { Form } from 'vee-validate';
import VueLoading from '@/components/general/Loading';
import FormControlInput from '@/components/general/FormControl/Input';

const UserRepository = RepositoryFactory.get('user');
const DomainRepository = RepositoryFactory.get('domain');

export default {
  name: 'change-password',

  props: {},
  emits: ['close'],

  setup(props, context) {
    const data = reactive({
      // Server-related errors
      errors: {},
      //show loading view
      loading: false,
    });
    const { toBool } = useConverter();

    //+---------------------+
    //|   computed          |
    //+---------------------+

    const user = computed(() => {
      return userStore.getState().user;
    });
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });
    const passwordAllowedCharacters = computed(() => {
      return '<strong> ! ? @ § # $ % & ( ) * + ~ - _ . , : ; < = > [ ] { } ^ ` " &#39; | / &#92; </strong>';
    });

    //+--------------------+
    //|    Methods         |
    //+--------------------+

    function emitClose(message) {
      context.emit('close', message);
    }

    const onSubmitChangePasswordForm = (values, actions) => {
      data.loading = true;
      data.errors = [];

      UserRepository.putPassword(user.value.id, values)
        .then(resp => {
          data.loading = false;
          actions.resetForm();
          emitClose(domainStore.translate('user.profile.password.success'));
        })
        .catch(err => {
          data.loading = false;
          const errData = err.response.data.message;
          if (errData.includes('old password')) {
            data.errors['old_password'] = errData;
          } else if (errData.includes('too weak')) {
            data.errors['new_password'] = errData;
            data.errors['new_password_repeat'] = errData;
          } else if (errData.includes('new password')) {
            data.errors['new_password_repeat'] = errData;
          } else {
            data.errors['old_password'] = errData;
          }
        });
    };

    return {
      // ---VARIABLE---
      domainStore,
      // Computed methods
      passwordAllowedCharacters,
      // Listeners
      onSubmitChangePasswordForm,
      emitClose,
      // Other
      toBool,
      data,
    };
  },

  components: {
    WdwDynbox,
    Form,
    FormControlInput,
    VueLoading,
  },
};
</script>
